<template>
  <div class="activities">
    <div class="title">
      <div></div>
      标签列表
    </div>
    <div class="query">
      <div class="query-box">
        <span>查询</span>
        <el-input v-model="query" placeholder="标签名称"></el-input>
      </div>
      <el-button type="primary" @click="inquire">查询</el-button>
       <el-button icon="el-icon-plus" type="primary" @click="addLabel"
        >新增</el-button
      >
    </div>
    <div class="activities-main">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column align="center" prop="name" label="标签名称">
        </el-table-column>

        <el-table-column align="center" prop="createTime" label="创建时间">
        </el-table-column>

        <el-table-column align="center" label="操作" width="240">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="delLabel(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 新增 -->
    <el-dialog title="添加标签" :visible.sync="addDialog" width="30%" center>
      <el-form :model="form" ref="form">
        <el-form-item label="标签名" label-width="80px" prop="name">
          <el-input v-model="form.name" autocomplete="off" maxlength="6"></el-input>
        </el-form-item>
       
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="addLab()">确 定</el-button>
      </span>
    </el-dialog>
  </div>


  
</template>


<script>
import local from "@/utils/local.js";
import { labelPage,delLabel,addLabel, IP } from "@/api/api";
export default {
  data() {
    return {
      //  activityId: "",
      ruleList: [],
      query: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      adminId: "",
         // 新增
      addDialog: false,
       form: {
        name: "",
      },
    };
  },
  created() {
    this.adminId = local.get("id");
    this.getList();
  },
  methods: {

    //删除标签
     async delLabel(id) {
        this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let { code } = await delLabel({ id });
          if (code === 200) {
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.getList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //添加标签
     async addLab() {
       if(this.form.name==''){
           this.$message({
            type: "danger",
            message: "标签名不能为空",
          });
         return false
       }
      let res = await addLabel({
        name: this.form.name,
      });
      if (res.code == 200) {
       this.addDialog = false;
            this.$message({
              type: "success",
              message: "修改成功",
            });
            this.form.name=''
            this.getList();
      }
    },


    //  获取用户列表
    async getList() {
      let res = await labelPage({
        query: this.query,
        pageSize: this.pageSize,
        pageNum: this.currentPage,
      });
      console.log(res);
      let { data } = res;
      //边界判断
      if (!data.itemList.length && this.currentPage !== 1) {
        this.currentPage -= 1;
        this.getList();
      }
      this.tableData = data.itemList;
      console.log(this.tableData, 9898);
      this.total = data.totalSize;
    },

    // 新增
    addLabel() {
      this.addDialog = true;
    },
    // 查询
    inquire() {
      this.getList();
    },
    // 刷新
    refresh() {
      this.query = "";
      this.getList();
    },

    //每页多少条
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    //当前多少页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.activities {
  // height: 100%;
  background: #fff;
  padding: 15px;
  color: #303133;
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    div {
      width: 3px;
      height: 16px;
      background: #409eff;
      margin-right: 10px;
    }
  }
  .query {
    margin: 15px 0 30px;
    display: flex;
    align-items: center;
    .query-box {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .el-input {
        width: 260px;
      }
      span {
        width: 60px;
      }
    }
  }
  .activities-main {
    margin: 15px 0;
  }
  .paging {
    display: flex;
    justify-content: flex-end;
  }
}
</style>